var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeco1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 255,
    viewBox: "0 0 779 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70231 -70.3341C1.70182 -70.3344 1.70138 -70.3347 1.70101 -70.3352C-4.20055 -76.7647 -11.4921 -82.6056 -19.5509 -88.1172C-20.0165 -88.4356 -20.5116 -88.7119 -21.027 -88.9485C-26.2387 -91.3417 -31.2227 -93.8839 -35.8468 -96.6599V-96.6599C-35.9576 -96.7141 -36.0592 -96.5638 -35.9633 -96.4874C-29.3038 -91.1832 -23.319 -85.6381 -18.4265 -79.704C11.0856 -43.8985 11.4491 24.5893 55.1576 50.286C71.3192 59.7876 90.149 61.5228 109.818 60.3873C99.599 59.6759 89.782 57.3769 80.6354 52.6051C36.9542 29.8119 32.3433 -36.9494 1.70362 -70.333C1.70324 -70.3335 1.7028 -70.3338 1.70231 -70.3341V-70.3341Z",
    fill: "url(#paint0_radial_2957_20994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.871 -6.40042C463.871 -6.4 463.87 -6.39964 463.87 -6.39934C457.521 -1.7524 451.95 4.19511 446.816 10.8697C446.361 11.4617 445.982 12.1051 445.672 12.7787C443.644 17.1769 441.435 21.3578 438.943 25.2007V25.2007C438.883 25.3229 439.05 25.4307 439.143 25.3296C444.265 19.7928 449.726 14.9019 455.736 11.0566C491.988 -12.1339 567.441 -5.00588 591.004 -42.3296C595.298 -49.1311 597.442 -56.733 598.106 -64.8705C598.301 -67.2663 591.941 -67.6022 590.785 -65.465V-65.465C570.419 -27.85 497.332 -30.8909 463.872 -6.40149C463.871 -6.40119 463.871 -6.40083 463.871 -6.40042V-6.40042Z",
    fill: "url(#paint1_radial_2957_20994)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.588 48.0524C228.588 48.0523 228.588 48.0521 228.588 48.052C220.345 46.9144 211.652 47.0953 202.683 48.016C202.416 48.0433 202.153 48.0964 201.897 48.1727C196.84 49.6776 191.786 50.9336 186.751 51.7995V51.7995C186.552 51.8526 186.592 52.1463 186.797 52.1427C194.357 52.0105 201.667 52.4459 208.602 53.7707C256.81 62.9836 310.611 115.84 356.312 107.943C364.421 106.541 371.599 103.343 378.132 98.8956C380.284 97.4305 376.717 92.6336 374.17 93.2228V93.2228C330.662 103.292 275.576 54.539 228.588 48.0527C228.587 48.0527 228.587 48.0524 228.588 48.0524V48.0524Z",
    fill: "url(#paint2_radial_2957_20994)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.818 60.3857C109.818 60.3857 109.818 60.3857 109.818 60.3857C118.373 60.981 127.21 60.4633 136.175 59.3499C133.064 59.3696 129.979 59.2412 126.929 58.937C126.551 58.8993 126.17 58.9009 125.792 58.9448C120.431 59.5681 115.094 60.0797 109.818 60.3848C109.818 60.3848 109.818 60.3854 109.818 60.3857V60.3857Z",
    fill: "url(#paint3_radial_2957_20994)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M396.855 81.4517C396.855 81.4517 396.855 81.4517 396.855 81.4517C400.657 78.2219 404.179 74.5188 407.506 70.4845C408.015 69.8664 406.943 68.9333 406.304 69.4249V69.4249C406.254 69.4631 406.211 69.5073 406.174 69.5574C403.15 73.6798 400.061 77.681 396.856 81.4518C396.856 81.4519 396.855 81.4518 396.855 81.4517V81.4517Z",
    fill: "url(#paint4_radial_2957_20994)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.174 59.3509C136.174 59.3514 136.174 59.3519 136.175 59.3519C144.567 59.2989 153.155 58.1689 161.818 56.4915C159.025 56.7312 156.245 56.8503 153.483 56.8289C152.787 56.8235 152.09 56.8771 151.403 56.9998C146.305 57.9105 141.219 58.7249 136.175 59.3506C136.175 59.3507 136.174 59.3508 136.174 59.3509V59.3509Z",
    fill: "url(#paint5_radial_2957_20994)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M421.054 51.2068C420.317 52.3834 421.411 53.1576 422.201 52.0137C423.78 49.7279 425.3 47.3549 426.778 44.9164C425.038 47.0823 423.197 49.1124 421.236 50.9836C421.167 51.0499 421.104 51.126 421.054 51.2068V51.2068Z",
    fill: "url(#paint6_radial_2957_20994)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475.366 -41.7798C475.366 -41.7798 475.367 -41.7794 475.366 -41.7792C467.5 -34.304 461.562 -24.2857 456.302 -13.384V-13.384C455.94 -12.2615 458.409 -11.0933 459.132 -12.041C462.558 -16.533 466.273 -20.5998 470.404 -24.0489C501.066 -49.6396 571.562 -50.4592 588.813 -88.1577C591.441 -93.9016 592.615 -100.025 592.714 -106.421C592.717 -106.644 592.69 -106.866 592.634 -107.081C592.334 -108.247 592.028 -109.415 591.716 -110.584C591.089 -112.934 586.043 -112.593 585.173 -110.296V-110.296C570.936 -72.7141 503.244 -68.2709 475.366 -41.7804C475.366 -41.7801 475.366 -41.7797 475.366 -41.7798V-41.7798Z",
    fill: "url(#paint7_radial_2957_20994)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9529 -55.9251C41.9527 -55.9248 41.9522 -55.9247 41.9519 -55.925C32.855 -63.9608 21.1651 -70.503 8.57498 -76.5197C3.87032 -78.1964 -0.722118 -79.9551 -5.12382 -81.8563C5.10538 -75.9905 14.4523 -69.6814 21.8671 -62.4123C53.4159 -31.4768 61.9999 33.3262 105.434 53.2689C112.077 56.3191 118.983 58.0659 126.073 58.8489C126.264 58.87 126.457 58.8688 126.648 58.8461C127.411 58.7558 128.175 58.6633 128.939 58.5689C131.497 58.2527 131.81 53.2869 129.441 52.3405V52.3405C86.464 35.1767 74.1915 -27.4475 41.9538 -55.9252C41.9535 -55.9255 41.9531 -55.9254 41.9529 -55.9251V-55.9251Z",
    fill: "url(#paint8_radial_2957_20994)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.184 33.227C265.184 33.2274 265.183 33.2276 265.183 33.2276C253.879 32.8627 242.026 35.2568 229.908 38.6459C225.585 40.425 221.251 42.0686 216.908 43.4698C227.459 41.4562 237.725 40.3458 247.47 41.176C293.073 45.0625 349.091 89.7075 390.317 77.6459C396.136 75.9436 401.273 73.2217 405.896 69.7332C406.118 69.5661 406.312 69.3675 406.474 69.1455C407.274 68.0522 408.07 66.9506 408.862 65.8428C410.301 63.8318 407.08 60.4919 404.72 61.3345V61.3345C365.851 75.2055 309.248 34.6513 265.185 33.2264C265.184 33.2264 265.184 33.2266 265.184 33.227V33.227Z",
    fill: "url(#paint9_radial_2957_20994)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M434.897 30.8073C434.445 31.3654 434.042 31.9593 433.708 32.5897C431.47 36.8094 429.182 40.9506 426.778 44.9181C431.132 39.5013 434.855 33.245 438.259 26.5587C438.308 26.464 438.181 26.3824 438.11 26.4621V26.4621C437.087 27.9696 436.019 29.4201 434.897 30.8073Z",
    fill: "url(#paint10_radial_2957_20994)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.787 52.8228C178.191 52.8718 177.598 52.9639 177.016 53.1066C171.94 54.3511 166.866 55.5127 161.818 56.491C169.199 55.8558 176.675 54.384 184.182 52.4704C184.342 52.4296 184.312 52.2053 184.147 52.2113V52.2113C182.358 52.4698 180.571 52.6762 178.787 52.8228Z",
    fill: "url(#paint11_radial_2957_20994)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.311 55.3747C151.244 55.5219 151.266 56.7872 152.341 56.811V56.811C152.404 56.8124 152.468 56.8073 152.53 56.796C158.793 55.6611 165.072 54.3912 171.315 53.1582C171.363 53.1487 171.357 53.0762 171.308 53.075V53.075C165.064 53.6723 158.712 54.4923 152.311 55.3747Z",
    fill: "url(#paint12_radial_2957_20994)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M416.434 55.0436C416.435 55.0428 416.435 55.042 416.436 55.0415C417.995 53.8827 419.485 52.6288 420.91 51.2915C421.057 51.153 421.185 50.9961 421.292 50.8257C424.372 45.8946 427.376 40.8315 430.402 35.803C430.421 35.772 430.38 35.7413 430.354 35.7666V35.7666C430.353 35.7676 430.352 35.7687 430.351 35.7699C425.567 41.9215 420.996 48.4776 416.434 55.0436V55.0436Z",
    fill: "url(#paint13_radial_2957_20994)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M202.083 47.2803C201.642 47.419 201.787 48.1083 202.247 48.0599V48.0599C202.271 48.0573 202.295 48.0525 202.318 48.0455C205.236 47.1687 208.157 46.2104 211.074 45.1985C208.351 45.9274 205.624 46.5461 202.896 47.0244C202.625 47.1098 202.354 47.1952 202.083 47.2803Z",
    fill: "url(#paint14_radial_2957_20994)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M445.495 10.9864C445.495 10.9872 445.494 10.9881 445.494 10.989C445.437 11.1189 445.38 11.2488 445.324 11.3787C445.126 11.8306 445.807 12.1956 446.106 11.7992V11.7992C446.125 11.7747 446.14 11.7486 446.153 11.7209C447.224 9.34634 448.245 6.91325 449.232 4.43632C448.08 6.72052 446.84 8.91028 445.495 10.9864V10.9864Z",
    fill: "url(#paint15_radial_2957_20994)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 49.5743C190.909 49.5741 190.909 49.5738 190.908 49.5738C188.617 50.1651 186.32 50.759 184.022 51.3463C183.529 51.4723 183.637 52.2269 184.145 52.2096V52.2096C185.012 52.0844 185.881 51.9465 186.75 51.7985C188.571 51.3113 190.393 50.8013 192.216 50.2737C192.833 50.0953 192.661 49.3027 192.027 49.4004C191.654 49.4576 191.282 49.5158 190.909 49.5748C190.909 49.5748 190.908 49.5745 190.909 49.5743V49.5743Z",
    fill: "url(#paint16_radial_2957_20994)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M439.943 20.5385C439.029 22.3207 438.117 24.1048 437.201 25.8839C436.93 26.4111 437.707 26.9051 438.108 26.4614V26.4614C438.39 26.0459 438.668 25.6256 438.942 25.2015C439.621 23.8392 440.288 22.4604 440.946 21.0686C441.284 20.3518 440.383 19.8764 439.942 20.5398V20.5398L439.943 20.5385Z",
    fill: "url(#paint17_radial_2957_20994)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M430.671 35.3554C430.671 35.3561 430.671 35.3568 430.671 35.3573C430.668 35.3615 430.666 35.3656 430.663 35.3698C430.642 35.405 430.689 35.44 430.719 35.411C431.931 34.2243 433.088 32.9697 434.194 31.6542C434.204 31.6419 434.213 31.6287 434.22 31.6146V31.6146C434.344 31.38 434.027 31.1817 433.857 31.3875C432.783 32.6871 431.722 34.0106 430.672 35.3533C430.671 35.3539 430.671 35.3547 430.671 35.3554V35.3554Z",
    fill: "url(#paint18_radial_2957_20994)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M172.12 52.9992C172.119 52.9996 172.119 52.9999 172.119 53C172.113 53.0011 172.107 53.0023 172.101 53.0034C172.052 53.0132 172.058 53.0856 172.108 53.0859C174.025 53.0973 175.948 53.029 177.874 52.8923C177.885 52.8915 177.896 52.8898 177.907 52.8871V52.8871C178.132 52.8318 178.086 52.5195 177.854 52.5352C175.955 52.6646 174.043 52.8208 172.121 52.9985C172.12 52.9985 172.12 52.9988 172.12 52.9992V52.9992Z",
    fill: "url(#paint19_radial_2957_20994)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M428.249 27.0007C428.249 27.0009 428.249 27.0014 428.249 27.0015C394.254 43.928 337.476 11.4101 296.885 14.4636C282.231 15.5653 267.236 21.9193 252.032 28.8168C248.769 30.4607 245.495 32.0373 242.204 33.496C255.674 28.5595 268.917 24.5613 281.671 24.2922C324.059 23.4013 380.912 59.9047 417.365 44.4118C422.171 42.3699 426.324 39.5482 429.973 36.1254C430.226 35.8879 430.458 35.6298 430.67 35.3571V35.3571C433.704 30.3227 436.761 25.3267 439.942 20.5361V20.5361C440.267 19.9039 439.042 19.1278 438.53 19.6307C435.547 22.5625 432.154 25.0548 428.249 26.9999C428.249 27.0001 428.249 27.0005 428.249 27.0007V27.0007Z",
    fill: "url(#paint20_radial_2957_20994)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.652 45.9811C174.653 45.9804 174.653 45.9796 174.652 45.9794C133.174 34.111 114.42 -23.5923 81.4376 -47.1747C68.4856 -56.4361 51.2744 -62.4749 33.6726 -68.2013C29.8764 -69.2871 26.1304 -70.4139 22.4747 -71.6168C37.1969 -65.7594 51.1343 -59.3739 61.8458 -50.8533C94.5603 -24.8317 110.226 35.4189 152.547 49.8878C158.732 52.0029 164.994 52.9689 171.306 53.0786C171.577 53.052 171.848 53.0274 172.118 53.002C178.438 51.7565 184.72 50.5557 190.909 49.5776C193.364 48.9442 195.817 48.3145 198.26 47.6999C190.399 48.6014 182.525 48.2341 174.653 45.9827C174.652 45.9825 174.652 45.9817 174.652 45.9811V45.9811Z",
    fill: "url(#paint21_radial_2957_20994)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M573.242 -152.493C573.241 -152.494 573.24 -152.493 573.24 -152.493C564.676 -115.71 503.115 -104.781 480.714 -77.0736C471.916 -66.1929 467.135 -51.0513 462.741 -35.5171C461.957 -32.1506 461.123 -28.8347 460.196 -25.6098C465.048 -38.4863 470.568 -50.5849 478.793 -59.4894C503.912 -86.6856 568.619 -94.5018 579.956 -131.775C581.614 -137.223 581.997 -142.865 581.43 -148.648C581.371 -148.9 581.314 -149.152 581.257 -149.402C579.195 -155.339 577.187 -161.236 575.435 -167.024C574.469 -169.347 573.508 -171.668 572.564 -173.978C574.414 -166.663 574.867 -159.475 573.244 -152.494C573.243 -152.493 573.242 -152.493 573.242 -152.493V-152.493Z",
    fill: "url(#paint22_radial_2957_20994)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M449.23 4.43701C449.23 4.43727 449.231 4.4371 449.231 4.43664C449.849 3.21098 450.441 1.95889 451.012 0.683215C451.098 0.491415 450.848 0.372619 450.741 0.553877V0.553877C450.736 0.562282 450.731 0.571125 450.728 0.580217C450.236 1.87492 449.737 3.16075 449.229 4.43597C449.229 4.43636 449.229 4.4368 449.23 4.43701V4.43701Z",
    fill: "url(#paint23_radial_2957_20994)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211.073 45.1985C213.02 44.6775 214.964 44.0978 216.907 43.4701C216.444 43.5581 215.981 43.648 215.517 43.74C215.014 43.8396 214.519 43.979 214.037 44.152C213.049 44.5063 212.06 44.8554 211.073 45.1985Z",
    fill: "url(#paint24_radial_2957_20994)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M224.88 40.101C224.88 40.1014 224.88 40.1019 224.88 40.1018C226.56 39.6013 228.237 39.1147 229.909 38.647C231.746 37.8912 233.58 37.1092 235.412 36.3127C233.112 37.1956 230.803 37.9994 228.487 38.7115C227.286 39.1752 226.084 39.6401 224.88 40.1008C224.88 40.1009 224.88 40.1009 224.88 40.101V40.101Z",
    fill: "url(#paint25_radial_2957_20994)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M214.004 44.0459C214.509 43.9423 215.007 43.8037 215.492 43.6274C218.627 42.4877 221.757 41.3011 224.88 40.1014C219.472 41.7125 214.022 43.4708 208.55 45.2236C210.375 44.8111 212.193 44.4171 214.004 44.0459Z",
    fill: "url(#paint26_radial_2957_20994)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M450.297 1.30547C450.586 0.81303 450.835 0.299451 451.035 -0.232224C452.108 -3.08122 453.148 -5.9685 454.178 -8.86825C451.983 -4.08149 449.88 0.826806 447.771 5.72363C448.602 4.23349 449.443 2.75953 450.297 1.30547Z",
    fill: "url(#paint27_radial_2957_20994)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M202.895 47.0248C204.781 46.4304 206.665 45.8275 208.549 45.2246C205.14 45.996 201.707 46.8309 198.26 47.6984C199.805 47.5208 201.351 47.296 202.895 47.0248Z",
    fill: "url(#paint28_radial_2957_20994)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M445.48 11.0117C445.49 10.9961 445.499 10.9796 445.506 10.9626C446.266 9.22241 447.019 7.47338 447.773 5.72435C446.847 7.38449 445.935 9.06398 445.033 10.7567C444.835 11.1281 445.251 11.3659 445.48 11.0117V11.0117Z",
    fill: "url(#paint29_radial_2957_20994)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M235.413 36.3121C235.413 36.3122 235.413 36.3122 235.413 36.3121C237.684 35.4412 239.948 34.4976 242.204 33.496C241.35 33.8092 240.493 34.1262 239.636 34.4465C238.229 35.0751 236.823 35.6983 235.413 36.3108C235.412 36.3111 235.412 36.3118 235.413 36.3121V36.3121Z",
    fill: "url(#paint30_radial_2957_20994)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M174.908 -497.865C174.908 -497.865 174.908 -497.865 174.907 -497.865C136.219 -492.812 79.8273 -521.428 48.316 -503.258C40.0528 -498.493 34.519 -491.097 30.4822 -482.254C29.1683 -478.536 27.8587 -474.811 26.5065 -471.134C25.3019 -466.95 24.1422 -462.719 22.952 -458.516C18.1053 -437.666 15.2531 -414.862 4.5076 -399.603C-15.2332 -371.573 -73.5211 -357.798 -79.4441 -321.677C-81.077 -311.717 -78.4835 -301.554 -73.6705 -291.329C-71.6764 -287.749 -69.6843 -284.179 -67.756 -280.63C-65.2601 -276.623 -62.7078 -272.622 -60.1992 -268.638C-46.9976 -249.296 -31.1744 -230.098 -26.2598 -211.983C-16.4745 -175.917 -41.8735 -127.268 -18.4111 -96.3617C-12.2592 -88.2572 -3.5035 -82.3714 6.68326 -77.7023C10.9254 -76.091 15.1737 -74.483 19.3744 -72.8411C24.1175 -71.2795 28.9075 -69.7539 33.6697 -68.2034C57.1806 -61.4826 82.6281 -56.3799 100.619 -44.8532C133.666 -23.6777 155.2 31.3302 195.661 40.7027C206.817 43.2868 217.737 42.0133 228.484 38.7091C232.213 37.2686 235.931 35.8288 239.633 34.4454C243.778 32.5908 247.91 30.6837 252.028 28.8149C271.909 18.8025 291.348 6.36983 310.78 3.8319C349.468 -1.22146 405.861 27.3946 437.372 9.22397C445.635 4.45958 451.169 -2.9367 455.206 -11.7792C456.52 -15.4979 457.829 -19.2226 459.182 -22.8998C460.386 -27.0837 461.546 -31.3146 462.736 -35.5173C467.583 -56.3676 470.435 -79.1719 481.181 -94.4309C500.921 -122.461 559.209 -136.236 565.132 -172.356C566.765 -182.316 564.172 -192.479 559.359 -202.705C557.365 -206.284 555.372 -209.854 553.444 -213.404C550.948 -217.411 548.396 -221.412 545.887 -225.395C532.685 -244.736 516.863 -263.936 511.948 -282.051C502.163 -318.116 527.562 -366.765 504.099 -397.672C497.947 -405.776 489.192 -411.662 479.005 -416.331C474.763 -417.943 470.514 -419.551 466.314 -421.192C461.571 -422.754 456.781 -424.28 452.018 -425.83C428.507 -432.551 403.06 -437.654 385.07 -449.18C352.022 -470.356 330.488 -525.364 290.027 -534.736C278.871 -537.32 267.951 -536.047 257.204 -532.743C253.476 -531.302 249.758 -529.862 246.055 -528.479C241.91 -526.624 237.778 -524.717 233.66 -522.848C213.78 -512.836 194.34 -500.404 174.908 -497.864C174.908 -497.864 174.907 -497.865 174.908 -497.865V-497.865ZM270.195 -528.177C309.476 -521.179 333.475 -468.998 366.396 -450.186C400.523 -430.683 459.083 -435.147 483.436 -406.413C507.788 -377.68 486.501 -329.242 498.09 -294.808C509.268 -261.59 559.176 -226.575 555.742 -191.278C552.308 -155.981 497.405 -139.636 480.255 -111.465C462.475 -82.2615 473.776 -28.0183 444.757 -8.79373C415.738 10.4309 360.027 -14.3877 323.333 -7.50108C287.936 -0.858745 254.777 41.1411 215.496 34.1429C176.214 27.1448 152.216 -25.0357 119.295 -43.8484C85.1673 -63.3514 26.6073 -58.8872 2.25478 -87.6207C-22.0978 -116.354 -0.810457 -164.791 -12.3992 -199.226C-23.5775 -232.444 -73.4858 -267.459 -70.0516 -302.756C-66.6174 -338.053 -11.7145 -354.398 5.43555 -382.569C23.2151 -411.772 11.9142 -466.016 40.9334 -485.24C69.9526 -504.465 125.663 -479.646 162.357 -486.533C197.754 -493.175 230.913 -535.175 270.195 -528.177Z",
    fill: "url(#paint31_radial_2957_20994)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2722 -467.103C35.272 -467.103 35.2714 -467.103 35.2709 -467.103C8.73887 -447.012 22.8812 -395.117 7.70102 -365.951C-6.9436 -337.816 -58.3792 -319.182 -59.4799 -284.858C-60.5815 -250.533 -10.7479 -219.224 1.98131 -187.662C15.1756 -154.944 -2.16923 -106.99 22.8672 -80.4442C47.9036 -53.8983 103.567 -61.227 137.369 -44.1141C169.978 -27.6053 196.122 21.6417 234.076 26.3917C272.032 31.1426 301.114 -11.1924 334.518 -19.4389C369.145 -27.9863 423.893 -6.83954 450.426 -26.9303C476.959 -47.021 462.816 -98.9171 477.997 -128.083C492.641 -156.218 544.077 -174.853 545.178 -209.176C546.279 -243.501 496.446 -274.81 483.716 -306.371C470.521 -339.089 487.866 -387.043 462.83 -413.589C437.793 -440.135 382.13 -432.806 348.328 -449.919C315.719 -466.428 289.575 -515.675 251.621 -520.425C213.665 -525.175 184.583 -482.84 151.181 -474.593C116.554 -466.046 61.8071 -487.192 35.2734 -467.102C35.273 -467.102 35.2723 -467.102 35.2722 -467.103V-467.103ZM234.366 -511.58C270.86 -508.939 298.832 -462.707 330.952 -448.435C364.248 -433.638 416.889 -443.575 442.405 -419.216C467.921 -394.857 454.331 -347.644 468.933 -316.716C483.018 -286.881 532.48 -259.193 533.545 -225.98C534.61 -192.766 486.698 -172.125 474.464 -144.196C461.782 -115.243 478.47 -65.8369 454.4 -45.0673C430.33 -24.2977 376.807 -41.9175 344.306 -31.8827C312.954 -22.2031 287.824 20.1856 251.329 17.5446C214.834 14.9036 186.862 -31.3275 154.743 -45.6009C121.447 -60.3976 68.8064 -50.4608 43.29 -74.8196C17.7736 -99.1784 31.3642 -146.392 16.7621 -177.32C2.67667 -207.155 -46.7856 -234.843 -47.8505 -268.056C-48.9155 -301.27 -1.0019 -321.91 11.2305 -349.84C23.913 -378.793 7.2246 -428.199 31.2948 -448.969C55.365 -469.738 108.888 -452.118 141.389 -462.153C172.741 -471.833 197.871 -514.221 234.366 -511.58Z",
    fill: "url(#paint32_radial_2957_20994)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9624 -430.948C7.31802 -409.683 26.2495 -362.889 15.9545 -334.315C6.02284 -306.751 -38.3344 -284.39 -35.2771 -252.41C-32.2198 -220.431 16.5865 -196.263 31.8352 -168.21C47.644 -139.129 37.6066 -92.8965 63.4054 -70.7119C89.2035 -48.526 138.721 -60.8064 171.339 -48.2426C202.805 -36.1225 232.286 7.03274 267.203 7.71036C302.12 8.38799 323.442 -33.7821 352.703 -44.7236C383.037 -56.0674 435.091 -41.8162 456.734 -63.082C478.378 -84.3469 459.447 -131.141 469.742 -159.715C479.673 -187.279 524.031 -209.64 520.973 -241.619C517.916 -273.599 469.11 -297.767 453.861 -325.82C438.052 -354.901 448.09 -401.133 422.291 -423.318C396.493 -445.504 346.975 -433.223 314.357 -445.787C282.891 -457.907 253.411 -501.063 218.494 -501.74C183.577 -502.418 162.254 -460.248 132.993 -449.306C102.66 -437.962 50.6053 -452.214 28.9624 -430.948ZM204.05 -491.013C237.285 -492.146 267.961 -452.107 298.619 -442.046C330.399 -431.618 376.719 -445.974 402.605 -425.935C428.493 -405.896 421.791 -360.87 438.605 -333.681C454.824 -307.453 502.705 -286.68 507.576 -256.048C512.447 -225.417 471.654 -201.618 463.904 -174.571C455.873 -146.533 476.742 -102.449 457.475 -80.8692C438.206 -59.2882 387.845 -70.3462 359.707 -57.8736C332.563 -45.8422 314.882 -4.15182 281.649 -3.01736C248.413 -1.88377 217.737 -41.9233 187.08 -51.9839C155.299 -62.4117 108.98 -48.0567 83.0934 -68.0953C57.2058 -88.1347 63.908 -133.16 47.0941 -160.349C30.8748 -186.577 -17.0061 -207.35 -21.8774 -237.982C-26.748 -268.615 14.0447 -292.412 21.7941 -319.459C29.826 -347.497 8.95611 -391.581 28.2239 -413.161C47.4926 -434.742 97.8532 -423.684 125.991 -436.157C153.135 -448.188 170.816 -489.878 204.05 -491.013Z",
    fill: "url(#paint33_radial_2957_20994)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0163 -395.718C12.0567 -373.996 34.5618 -332.699 28.6586 -305.346C22.9652 -278.961 -14.284 -254.009 -7.78425 -224.821C-1.28451 -195.632 45.4204 -178.116 62.4178 -153.74C80.0383 -128.47 76.4402 -84.8602 102.232 -66.925C128.023 -48.9898 171.091 -65.1498 201.885 -56.7506C231.59 -48.6495 263.152 -11.737 294.617 -14.5236C326.083 -17.3101 340.302 -58.2758 365.32 -71.2232C391.255 -84.6454 439.717 -76.591 456.677 -98.313C473.636 -120.035 451.131 -161.331 457.034 -188.684C462.728 -215.07 499.975 -240.022 493.477 -269.21C486.977 -298.398 440.273 -315.914 423.275 -340.291C405.655 -365.561 409.253 -409.171 383.461 -427.106C357.67 -445.041 314.602 -428.881 283.808 -437.28C254.103 -445.381 222.54 -482.292 191.075 -479.507C159.61 -476.721 145.391 -435.755 120.373 -422.808C94.4383 -409.385 45.9759 -417.44 29.0163 -395.718ZM116.124 -409.356C139.021 -423.048 149.98 -463.056 179.603 -467.332C209.226 -471.608 241.37 -437.819 269.993 -431.562C299.666 -425.076 339.458 -442.769 364.977 -426.883C390.496 -410.997 389.756 -368.993 407.988 -345.658C425.575 -323.148 470.869 -308.729 478.81 -281.07C486.751 -253.41 453.008 -227.585 449.229 -201.99C445.313 -175.458 469.15 -137.003 454.42 -115.307C439.689 -93.6116 393.309 -98.8674 369.574 -84.6737C346.677 -70.9816 335.718 -30.9729 306.095 -26.697C276.472 -22.4211 244.328 -56.21 215.705 -62.4676C186.032 -68.953 146.24 -51.2608 120.721 -67.1467C95.2016 -83.0326 95.9419 -125.036 77.7105 -148.371C60.1233 -170.882 14.8286 -185.301 6.88787 -212.96C-1.05284 -240.619 32.6899 -266.445 36.469 -292.039C40.3849 -318.571 16.5478 -357.027 31.2782 -378.722C46.0086 -400.418 92.3889 -395.162 116.124 -409.356Z",
    fill: "url(#paint34_radial_2957_20994)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1237 -279.605C43.117 -254.926 12.8159 -228.5 22.0058 -202.439C31.1957 -176.379 74.8677 -164.886 92.8564 -144.241C111.504 -122.839 113.369 -82.6129 138.447 -68.7111C163.524 -54.8093 200.039 -73.7586 228.465 -69.0623C255.888 -64.5313 288.318 -33.8364 316.043 -39.4333C343.767 -45.0301 351.678 -83.868 372.475 -98.1318C394.033 -112.919 438.171 -110.248 450.762 -131.754C463.354 -153.26 438.488 -188.844 440.568 -214.427C442.574 -239.107 472.875 -265.533 463.686 -291.593C454.496 -317.654 410.824 -329.147 392.835 -349.792C374.187 -371.193 372.322 -411.42 347.245 -425.321C322.167 -439.223 285.652 -420.274 257.226 -424.97C229.804 -429.501 197.373 -460.196 169.649 -454.599C141.924 -449.002 134.014 -410.165 113.216 -395.901C91.6578 -381.114 47.5205 -383.785 34.929 -362.279C22.3375 -340.773 47.2033 -305.188 45.1237 -279.605ZM111.621 -382.541C130.35 -397.209 135.44 -434.678 161.227 -441.424C187.013 -448.171 219.443 -420.52 245.562 -417.587C272.637 -414.545 305.893 -434.483 330.372 -422.487C354.851 -410.491 359.058 -372.193 377.934 -352.714C396.143 -333.923 437.999 -325.169 448.245 -300.762C458.491 -276.356 431.546 -249.598 431.157 -225.941C430.755 -201.418 456.355 -168.717 445.799 -147.553C435.243 -126.389 393.486 -126.7 374.071 -111.494C355.343 -96.8265 350.253 -59.3572 324.466 -52.6106C298.68 -45.864 266.25 -73.5146 240.131 -76.4484C213.056 -79.4899 179.8 -59.5521 155.321 -71.5482C130.842 -83.5443 126.635 -121.842 107.759 -141.321C89.5504 -160.112 47.6942 -168.866 37.448 -193.273C27.2019 -217.679 54.1474 -244.437 54.5356 -268.094C54.9383 -292.617 29.3379 -325.318 39.894 -346.482C50.4501 -367.646 92.2064 -367.335 111.621 -382.541Z",
    fill: "url(#paint35_radial_2957_20994)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5988 -257.555C65.6707 -235.02 41.9728 -208.191 53.0839 -185.48C64.195 -162.769 104.061 -156.553 122.314 -139.589C141.235 -122.004 147.514 -85.7661 171.248 -75.5865C194.981 -65.4056 225.022 -86.0635 250.652 -84.5389C275.376 -83.0676 307.53 -58.3904 331.354 -66.1158C355.177 -73.8412 357.685 -109.76 374.396 -124.668C391.718 -140.121 430.978 -141.937 439.613 -162.615C448.25 -183.292 422.206 -213.119 421.094 -236.482C420.022 -259.017 443.72 -285.846 432.609 -308.557C421.498 -331.267 381.632 -337.484 363.379 -354.448C344.458 -372.033 338.178 -408.271 314.445 -418.45C290.712 -428.631 260.671 -407.973 235.041 -409.498C210.317 -410.969 178.162 -435.646 154.339 -427.921C130.516 -420.196 128.008 -384.277 111.297 -369.369C93.9747 -353.916 54.7146 -352.1 46.0796 -331.422C37.4446 -310.744 63.4869 -280.917 64.5988 -257.555ZM112.199 -356.475C126.952 -371.462 127.127 -405.669 148.978 -414.201C170.83 -422.733 202.449 -400.938 225.699 -400.789C249.803 -400.633 276.696 -421.748 299.548 -413.284C322.399 -404.821 330.476 -370.755 349.266 -355.024C367.393 -339.848 405.118 -335.961 416.903 -314.972C428.688 -293.983 408.109 -267.332 410.477 -246.005C412.933 -223.895 439.137 -196.907 432.297 -176.852C425.458 -156.798 388.787 -153.095 373.495 -137.559C358.742 -122.573 358.567 -88.3656 336.715 -79.8338C314.864 -71.3021 283.245 -93.0968 259.994 -93.2462C235.891 -93.4014 208.997 -72.287 186.145 -80.7507C163.295 -89.2136 155.218 -123.28 136.428 -139.011C118.301 -154.187 80.5757 -158.074 68.7906 -179.063C57.0055 -200.052 77.5845 -226.703 75.2161 -248.03C72.761 -270.139 46.5569 -297.127 53.3966 -317.183C60.2355 -337.237 96.9064 -340.94 112.199 -356.475Z",
    fill: "url(#paint36_radial_2957_20994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-42.0923 -29.0778) rotate(-163.267) scale(392.768 106.351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(472.579 -3.33008) rotate(160.99) scale(272.29 153.407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.229 50.9678) rotate(-164.25) scale(369.095 106.427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.467 59.2391) rotate(-171.662) scale(43.2646 17.6415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.306 77.1152) rotate(137.168) scale(27.9055 8.14556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.768 57.8433) rotate(-174.926) scale(41.2325 18.6271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(415.911 59.1914) rotate(129.572) scale(26.9414 4.00954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.327 -32.3423) rotate(155.474) scale(244.292 129.845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.06051 -27.5769) rotate(-160.782) scale(375.551 84.4639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.379 38.9212) rotate(-167.492) scale(338.114 116.174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.055 40.183) rotate(127.62) scale(25.6963 2.81984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.094 54.7479) rotate(-178.307) scale(37.1421 18.2327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.15 54.7232) rotate(-175.499) scale(42.0992 19.318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(419.675 50.4423) rotate(129.287) scale(27.6408 3.95698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.378 47.3859) rotate(178.166) scale(20.4269 10.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(444.492 12.3139) rotate(131.922) scale(14.0082 2.72917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.138 50.9555) rotate(-179.683) scale(28.4731 14.3737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.711 26.1276) rotate(130.951) scale(19.7899 3.48232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.566 34.224) rotate(134.544) scale(8.61534 2.10592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.147 52.6543) rotate(-173.606) scale(13.162 5.72113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.164 22.4296) rotate(-174.083) scale(325.588 143.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2391 -31.0665) rotate(-157.781) scale(392.352 65.5551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(481.758 -63.2584) rotate(147.846) scale(237.941 108.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(449.414 2.80779) rotate(134.063) scale(7.50562 1.76747)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.159 44.6263) rotate(176.194) scale(9.02884 4.86823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.865 38.9269) rotate(173.008) scale(16.1755 9.0239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.601 43.5615) rotate(175.325) scale(25.2087 13.7383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(448.022 1.56231) rotate(135.581) scale(18.7365 4.93675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.153 46.8113) rotate(178.947) scale(16.0682 8.31489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(443.873 12.1538) rotate(130.38) scale(11.3986 1.87818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.706 35.4745) rotate(170.232) scale(10.3889 5.90459)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.8257 -234.824) rotate(-177.795) scale(1325.8 643.557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.76737 -235.603) rotate(-177.795) scale(1241.01 602.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.19791 -236.194) rotate(-177.795) scale(1176.55 571.111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6979 -236.949) rotate(-177.795) scale(1094.51 531.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1219 -237.839) rotate(-177.795) scale(997.936 484.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2957_20994",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.7839 -238.831) rotate(-177.795) scale(890.243 432.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    xmlns: "http://www.w3.org/2000/svg",
    attributeName: "gradientTransform",
    attributeType: "XML",
    type: "scale",
    values: "188.8954 108.3446; 368.8954 216.3446; 188.8954 108.3446",
    dur: "5s",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco1);
export default __webpack_public_path__ + "static/media/deco1.5445e977cb7e5ee3475450d2b1c49f33.svg";
export { ForwardRef as ReactComponent };